<script>
import Vue from 'vue';
import Occupation from '~/models/Occupation';
import ResourceSelect from '~/components/ResourceSelect/ResourceSelect.vue';

export default Vue.extend({
  extends: ResourceSelect,

  props: {
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },

    getOptionLabel: {
      type: Function,
      required: false,
      default: (resource) => resource.name,
    },

    query: {
      type: Object,
      required: false,
      default: () => new Occupation(),
    },

    searchable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  methods: {
    async fetch() {
      return await this.query.$all();
    },
  },
});
</script>
